import { render, staticRenderFns } from "./orderComponent.vue?vue&type=template&id=0d3e9d2a&scoped=true&"
import script from "./orderComponent.vue?vue&type=script&lang=ts&"
export * from "./orderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e9d2a",
  null
  
)

export default component.exports